import React from "react"
import Loader from "react-loader-spinner"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { validateForm } from "../../../../../../services/validation"
import { saveAboutMe } from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import Form, { Group } from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"
import RadioCard from "../../../../components/RadioCard"
import iconBank from "./images/icon-bank.svg"
import iconBankLight from "./images/icon-bank-light.svg"
import iconManager from "./images/icon-manager.svg"
import iconManagerLight from "./images/icon-manager-light.svg"
import iconMoney from "./images/icon-money.svg"
import iconMoneyLight from "./images/icon-money-light.svg"

class ManagingFunds extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        managingYourFunds: {
          name: "managingYourFunds",
          type: "radio",
          value: "",
          options: [
            {
              title: "Let The NDIA Manage My Funds And Pay My Providers",
              description:
                "With this option, you can only choose from NDIS registered service providers. You cannot use unregistered providers. The Agency will manage all your payments to your service providers and you can view these transactions on the MyPlace portal. With this option, there is nothing you have to do apart from selecting your NDIS registered service providers.",
              value: "NDIA",
              icon: iconManager,
              iconLight: iconManagerLight,
              iconTitle: "Manager"
            },
            {
              title: "Let A Professional Organisation Manage My Fund",
              description:
                "With this option, you must select a NDIS registered Plan Manager. The cost of having a Plan Manager is covered in your plan. The Plan Manager will pay your service providers, keep track of your funds and report regularly to the NDIS on your behalf.",
              value: "PROF",
              icon: iconBank,
              iconLight: iconBankLight,
              iconTitle: "Bank"
            },
            {
              title: "I Would Like To Manage My Own Funds",
              description:
                "With this option, you are responsible for; organising your service providers (NDIS registered or not), paying your service providers, staying within your budget and intent of the funding and, if you wish, employing staff for services. (Note: Family members cannot be employed)<br /><br />Managing your own funds gives you control and independence BUT there are additional requirements and responsibilities. Talk to your LAC or Planner about this option for more information.",
              value: "SELF",
              icon: iconMoney,
              iconLight: iconMoneyLight,
              iconTitle: "Money"
            }
          ],
          required: true
        }
      }
    }
  }

  componentDidMount() {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.aboutMe) {
      this.setForm()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.aboutMe) {
      if (
        JSON.stringify(prevProps.store.plan.answers.aboutMe) !==
        JSON.stringify(plan.answers.aboutMe)
      ) {
        this.setForm()
      }
    }
  }

  setForm = () => {
    const { form } = this.state
    const {
      store: { plan }
    } = this.props

    this.setState({
      form: {
        managingYourFunds: {
          ...form.managingYourFunds,
          value: plan.answers.aboutMe.fund_management
        }
      }
    })
  }

  scrollToInvalidElement = fields => {
    Object.keys(fields).map((resKey, index) => {
      if (fields[resKey].message && index === 0) {
        const item = this.form.elements[resKey]
        const parent = item.closest
          ? item.closest(".form_group")
          : item[0].closest(".form_group")
        const offSet = parent.getBoundingClientRect().top + window.pageYOffset
        const supportsNativeSmoothScroll =
          "scrollBehavior" in document.documentElement.style

        if (supportsNativeSmoothScroll) {
          window.scrollTo({
            top: offSet,
            behavior: "smooth"
          })
        } else {
          window.scrollTo(0, offSet)
        }
      }

      return null
    })
  }

  scrollToNextButton = () => {
    let offSet =
      this.form.getBoundingClientRect().bottom +
      window.pageYOffset -
      window.innerHeight
    const supportsNativeSmoothScroll =
      "scrollBehavior" in document.documentElement.style

    if (window.innerWidth <= 767) {
      offSet += 200
    } else {
      offSet += 100
    }

    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: offSet,
        behavior: "smooth"
      })
    } else {
      window.scrollTo(0, offSet)
    }
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })

    this.scrollToNextButton()
  }

  handleNext = () => {
    const { form } = this.state
    const {
      history,
      onSaveAboutMe,
      store: { user, plan }
    } = this.props

    if (user.list_role.includes(configs.roles.Guardian)) {
      history.push("/pre-plan/review")
    }

    const results = validateForm(form)

    if (Object.keys(results).length === 0 && results.constructor === Object) {
      const item = { fund_management: form.managingYourFunds.value }
      onSaveAboutMe(user.token, plan.id, item).then(() => {
        history.push("/pre-plan/almost")
      })
    } else {
      this.scrollToInvalidElement(results)

      this.setState({
        form: {
          ...form,
          ...results
        }
      })
    }
  }

  render() {
    const {
      onBack,
      store: { plan }
    } = this.props
    const { form } = this.state

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">Managing Your Funds</div>
          <div className="pre-plan_description">
            Now that you have finished your pre-plan, how would you like to have
            your funds managed? There are three options below. You can select
            one or a combination. Your LAC or Planner will offer advice and help
            you make a decision.
          </div>
        </div>

        {plan.loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="pre-plan_title">
                How Would You Like To Manage Your Funds
              </div>
              <Form
                formRef={el => {
                  this.form = el
                }}
              >
                <Group className="form_group--padding-top-lg">
                  {form.managingYourFunds.message && (
                    <div className="form_message">
                      <em>
                        By clicking on one of the boxes below, please select how
                        you want your NDIS funds to be managed.
                      </em>
                    </div>
                  )}

                  <RadioCard
                    options={form.managingYourFunds.options}
                    name={form.managingYourFunds.name}
                    defaultValue={form.managingYourFunds.value}
                    className="card--gray"
                    classNameActive="card--green"
                    onChange={this.onChange}
                  />
                </Group>

                <Group className="form_btn-group form_group--padding-top-lg">
                  <Button
                    button={{ type: "button" }}
                    onClick={onBack}
                    className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                  >
                    Back
                  </Button>

                  <Button
                    button={{ type: "button" }}
                    onClick={this.handleNext}
                    className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                  >
                    Next
                  </Button>
                </Group>
              </Form>
            </div>
          </div>
        )}
      </>
    )
  }
}

ManagingFunds.propTypes = {
  onBack: propTypes.func.isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  onSaveAboutMe: propTypes.func.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        aboutMe: propTypes.shape({
          fund_management: propTypes.oneOfType([
            propTypes.string,
            propTypes.number
          ]),
          support_me: propTypes.string,
          daily_life: propTypes.string,
          about_me: propTypes.string,
          health_and_wellbeing: propTypes.string,
          safety_concerns: propTypes.string,
          communication_and_decision_making: propTypes.string,
          studying: propTypes.string,
          transportation: propTypes.string,
          extra_info: propTypes.string
        })
      })
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveAboutMe: (token, planId, aboutMe) =>
    dispatch(saveAboutMe(token, planId, aboutMe))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManagingFunds)
)
